'use strict';
const CATEGORIES = ['Sales', 'Management', 'Operations', 'Marketing', 'Service', 'Other'];
const SOCIAL_FIELDS = ['facebook', 'tiktok', 'instagram', 'youtube'];
const DOMAINS = {facebook:['facebook.com','fb.com'],tiktok:['tiktok.com'],instagram:['instagram.com'],youtube:['youtube.com','youtu.be']};
const own = (o,k) => Object.prototype.hasOwnProperty.call(o || {}, k);
function normalizeLink(raw, platform) {
  if (typeof raw !== 'string') throw Error('Social links must be text.');
  const s=raw.trim(); if (!s) return '';
  if (s.length>2048) throw Error('A social link is too long.');
  let u; try { u=new URL(s.includes('://') ? s : 'https://'+s); } catch { throw Error('Enter a complete profile URL.'); }
  if (!['https:','http:'].includes(u.protocol)||u.username||u.password||u.port||!u.hostname.includes('.')||/^[\d.]+$/.test(u.hostname)||u.hostname.endsWith('.local')) throw Error('Use a public HTTPS profile URL.');
  u.protocol='https:';
  if (platform && (!DOMAINS[platform].some(d=>u.hostname===d||u.hostname.endsWith('.'+d)) || u.pathname==='/')) throw Error('Enter a '+platform+' profile link in the '+platform+' field.');
  return u.toString();
}
function normalizeProfile(input) {
  const out={};
  if (own(input,'directoryCategory')) {
    const c=String(input.directoryCategory||'').trim();
    if(c&&!CATEGORIES.includes(c)) throw Error('Choose a valid directory category.'); out.directoryCategory=c;
  }
  if(own(input,'directoryTitle')) {
    if(typeof input.directoryTitle!=='string'||input.directoryTitle.length>100)throw Error('Job title must be 100 characters or fewer.');
    out.directoryTitle=input.directoryTitle.trim();
  }
  if(own(input,'socialProfiles')) {
    const p=input.socialProfiles;
    if(!p||typeof p!=='object'||Array.isArray(p))throw Error('Invalid social profile fields.');
    out.socialProfiles={};
    for(const k of SOCIAL_FIELDS) out.socialProfiles[k]=normalizeLink(p[k]||'',k);
    const additional=p.additional||[];
    if(!Array.isArray(additional)||additional.length>10)throw Error('Add up to 10 additional social links.');
    out.socialProfiles.additional=additional.filter(x=>x&&(x.label||x.url)).map(x=>{
      if(typeof x.label!=='string'||!x.label.trim()||x.label.length>60||typeof x.url!=='string'||!x.url.trim())throw Error('Each additional link needs a label and a URL.');
      return {label:x.label.trim(),url:normalizeLink(x.url)};
    });
  }
  return out;
}
function locationIds(u) {
  return [...new Set([...(u.salesLocations||[]),u.salesLocation].filter(Boolean).map(x=>String(x._id||x)))];
}
function locationLabels(u) {
  return [...new Set([...(u.salesLocations||[]),u.salesLocation].filter(Boolean).map(x=>x.location||'').filter(Boolean))];
}
function roleNames(u){return Array.isArray(u.roles)&&u.roles.length?u.roles:u.role?[u.role]:[];}
function normalizeFilters(f={}) {
  const out={query:String(f.query||'').trim().slice(0,200),status:f.status||'all'};
  for(const k of ['stores','roles','categories']) {
    if(f[k]!==undefined&&(!Array.isArray(f[k])||f[k].length>200||f[k].some(x=>typeof x!=='string')))throw Error('Invalid directory filter.');
    out[k]=[...new Set(f[k]||[])];
  }
  if(!['all','enabled','disabled','registered','unregistered'].includes(out.status))throw Error('Invalid account status.');
  return out;
}
function matchesFilters(u,filters) {
  const f=normalizeFilters(filters),ids=locationIds(u),roles=roleNames(u);
  if(u.reportingOnly&&!f.query)return false;
  if(f.stores.length&&!f.stores.some(s=>s==='__UNSPECIFIED_LOCATION__'?!ids.length:ids.includes(s)))return false;
  if(f.roles.length&&!f.roles.some(r=>roles.includes(r)))return false;
  if(f.categories.length&&!f.categories.includes(u.directoryCategory||'__UNCATEGORIZED__'))return false;
  if(f.status==='enabled'&&u.enabled===false)return false;
  if(f.status==='disabled'&&u.enabled!==false)return false;
  if(f.status==='registered'&&!u.active)return false;
  if(f.status==='unregistered'&&u.active)return false;
  const text=[u.name,u.email,u.phone,u.directoryTitle,u.directoryCategory,...roles,...locationLabels(u),...SOCIAL_FIELDS.map(k=>u.socialProfiles?.[k])].join(' ').toLowerCase();
  return !f.query||text.includes(f.query.toLowerCase());
}
module.exports={CATEGORIES,SOCIAL_FIELDS,own,normalizeLink,normalizeProfile,locationIds,locationLabels,roleNames,normalizeFilters,matchesFilters};
